import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Sparkle } from "lucide-react";

export default function LegalPage({ title, updated, intro, sections, testId }) {
    return (
        <main data-testid={testId} className="min-h-screen bg-cream text-navy">
            <header className="border-b border-warmgray bg-cream/80 backdrop-blur-xl">
                <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-5">
                    <Link to="/" data-testid={`${testId}-logo`} aria-label="Ago GenApp home">
                        <img src="/logo.png" alt="Ago GenApp" className="h-10 w-auto" />
                    </Link>
                    <Link
                        to="/"
                        data-testid={`${testId}-back-home`}
                        className="flex items-center gap-2 rounded-full border-2 border-navy px-5 py-2 text-sm font-semibold text-navy transition-transform duration-300 hover:-translate-y-0.5"
                    >
                        <ArrowLeft size={15} /> Back Home
                    </Link>
                </div>
            </header>

            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
                className="mx-auto max-w-4xl px-6 py-16 md:py-24"
            >
                <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.35em] text-[#C98A94]">Last updated · {updated}</p>
                <h1 className="font-display text-4xl tracking-tight md:text-5xl">{title}</h1>
                <p className="mt-6 max-w-2xl text-base leading-relaxed text-navy">{intro}</p>

                <div className="mt-12 space-y-10">
                    {sections.map((s, i) => (
                        <section key={s.heading} data-testid={`${testId}-section-${i}`} className="border-t-2 border-warmgray pt-8">
                            <h2 className="font-display text-2xl tracking-tight">{s.heading}</h2>
                            <p className="mt-4 text-sm leading-relaxed text-navy md:text-base">{s.body}</p>
                        </section>
                    ))}
                </div>

                <p className="mt-16 rounded-3xl border-2 border-warmgray bg-ivory p-6 text-sm leading-relaxed text-navy">
                    Questions about this policy? Write to us at <span className="font-semibold">hello@agogenapp.com</span> — a human reads every message.
                </p>
            </motion.div>
        </main>
    );
}
